export enum BackendTranslationKey {
  BadRequest = 'onarte.website.errors.400.message',
  LoginRequired = 'onarte.website.errors.401.message',
  AccessDenied = 'onarte.website.errors.403.message',
  NotFound = 'onarte.website.errors.404.message',
  Conflict = 'onarte.website.errors.409.message',
  InternalError = 'onarte.website.errors.500.message',
}
